// riskTypes.js
export default {
    "SENSITIVE": "涉敏",
    "POLITICS": "涉政",
    "PORN": "色情",
    "AD": "广告",
    "ABUSE": "辱骂",
    "ADD_WATER": "灌水",
    "PROHIBIT": "违禁品",
    "DISCRIMINATION": "种族歧视",
    "RELIGION": "宗教",
    "DISGUST": "恶心",
    "VULGAR": "低俗",
    "NEGATIVE": "负面",
    "SUPERSTITION": "封建迷信",
    "TERRORISM": "暴恐",
    "GAMBLING": "赌博",
    "CHILD_ABUSE": "虐童",
    "COMPET": "竞品",
    "FRAUD": "欺诈"
}